import {SvgIcon} from '@mui/material';

export const KeyboardDoubleArrowLeft = (props) => (
    <SvgIcon {...props}>
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M17.59 18 19 16.59 14.42 12 19 7.41 17.59 6l-6 6z" />
        <path d="m11 18 1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z" />
    </SvgIcon>
);

export const KeyboardDoubleArrowRight = (props) => (
    <SvgIcon {...props}>
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z" />
        <path d="m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z" />
    </SvgIcon>
);
